import { SAVE_AND_SUBMIT_ACTION, REST_API_ACTION, LOOKUP_ACTION, } from "../constants/common";
var formatFormioJSON = function (form) {
    var formatComponents = function (components) {
        if (components && components.length > 0) {
            components.forEach(function (element) {
                if (element.type === "button") {
                    switch (element.action) {
                        case SAVE_AND_SUBMIT_ACTION:
                            element.action = "event";
                            element.event = SAVE_AND_SUBMIT_ACTION;
                            break;
                        case REST_API_ACTION:
                            element.action = "event";
                            element.event = REST_API_ACTION;
                            break;
                        case LOOKUP_ACTION:
                            element.action = "event";
                            element.event = LOOKUP_ACTION;
                            break;
                    }
                }
                else if (["panel", "container", "editgrid"].includes(element.type)) {
                    formatComponents(element.components);
                }
                else if (element.type === "columns") {
                    var columns = element.columns;
                    if (columns && columns.length > 0) {
                        columns.forEach(function (col) {
                            formatComponents(col.components);
                        });
                    }
                    formatComponents(element.components);
                }
                else if (element.type === "tabs") {
                    var tabs = element.components;
                    if (tabs && tabs.length > 0) {
                        tabs.forEach(function (tab) {
                            formatComponents(tab.components);
                        });
                    }
                    formatComponents(element.components);
                }
            });
        }
    };
    formatComponents(form === null || form === void 0 ? void 0 : form.components);
    return form;
};
export default formatFormioJSON;
//# sourceMappingURL=FormatFormioJSON.js.map